var path = 'src/app/patients/diagnoses/primary-diagnosis.html';
var html = "<h1 class=page-header>Primary Diagnosis <small>{{cohort.name}}</small></h1> <div primary-patient-diagnosis-component patient=patient cohort=cohort></div> <h2 class=page-header>Renal Disease Progression</h2> <div renal-progression-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/diagnoses/primary-diagnosis.html
 ** module id = 438
 ** module chunks = 0
 **/